/* global $*/
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { makeAPI } from "../../services/api";
import { getViteImage } from "../../utils/utils";
export default function CreatorCommunity() {
    const [activeTab, setActiveTab] = useState('support creator');
    const [CreatorStatus, setCreatorStatus] = useState('creator_dashboard');
    var socialMediaData = {};
    const user = JSON.parse(localStorage.getItem('user'));
    const isLoggedIn = Boolean(user?.user_id);
    // console.log("USER",user);
    // const { user ;} = {
    //     user_id:10005
    // };
    const [showbutton,setbutton]=useState(false);
    // Use Effect
    useEffect(() => {
        document.title = "Creator - CGES.CLUB";
        if (!isLoggedIn) return;
        //set the creator status  initialy.
        if (activeTab === 'become a creator') {
            GetCreatorStat();
        }else if(activeTab === 'support creator'){
            GetCreatorCode();
        }
    }, [activeTab, isLoggedIn]);
    // Jquery Step form.
    useEffect(() => {
        if (typeof $ === "undefined") return;
        if (activeTab !== "become a creator" || CreatorStatus !== "form") return;

        var navListItems = $('div.setup-panel div a'),
            allWells = $('.setup-content'),
            allNextBtn = $('.nextBtn');

        if (!navListItems.length || !allWells.length) return;

        /* ---------- INITIAL STATE ---------- */
        allWells.hide();

        navListItems
            .addClass('disabled')
            .removeClass('active completed');

        navListItems.first()
            .removeClass('disabled')
            .addClass('active')
            .css('background-color', '#ff810e');

        $('#step-1').show();

        /* ---------- PREVENT STEP SKIPPING ---------- */
        navListItems.on('click.stepper', function (e) {
            e.preventDefault();
            // prevent clicking on disabled tabs
            // previous step color removal while onclick completed step

            if ($(this).hasClass('disabled')) return;

            var target = $($(this).attr('href'));
            // Add validation here if required
            // if step 1 check the both input fields are valid else return
            // if step 2 range picker value is valid else return
            // if step 3 social media links are valid else return
            var step1Inputs;
            var step2Input;
            var step3Inputs;
            var ischecked1, ischecked2;
            var ageValue;
            if (target.attr('id') === 'step-2') {
                step1Inputs = $('#step-1').find("input[type='checkbox']");
                 ischecked1 = step1Inputs[0].checked;
                 ischecked2 = step1Inputs[1].checked;
                // console.log(ischecked1, ischecked2);
                if (!ischecked1 || !ischecked2) return;
            }
            if (target.attr('id') === 'step-3') {
                 step2Input = $('#step-2').find("input[type='range']");
                 ageValue = parseInt(step2Input.val());
                step1Inputs = $('#step-1').find("input[type='checkbox']");
                 ischecked1 = step1Inputs[0].checked;
                 ischecked2 = step1Inputs[1].checked;
                if (!ischecked1 || !ischecked2) return;
                if (ageValue < 15) return;
            }
            if (target.attr('id') === 'step-4') {
                 step3Inputs = $('#step-3').find("input[type='text']");
                var allFilled = true;
                step3Inputs.each(function () {
                    if ($(this).val().trim() === '') {
                        allFilled = false;
                    }
                });
                 step2Input = $('#step-2').find("input[type='range']");
                 ageValue = parseInt(step2Input.val());
                 step1Inputs = $('#step-1').find("input[type='checkbox']");
                 ischecked1 = step1Inputs[0].checked;
                 ischecked2 = step1Inputs[1].checked;
                if (!ischecked1 || !ischecked2) return;
                if (ageValue < 15) return;
                if (!allFilled) return;
            }
            navListItems.removeClass('active');
            $(this).addClass('active')
                .css('background-color', '#4ded62ff');

            allWells.hide();
            target.show();
        });

        /* ---------- NEXT BUTTON (LINEAR MOVE) ---------- */
        allNextBtn.on('click.stepper', function () {

            var curStep = $(this).closest(".setup-content"),
                curStepId = curStep.attr("id"),
                curStepLink = $('div.setup-panel a[href="#' + curStepId + '"]'),
                nextStepLink = curStepLink.parent().next().find('a'),
                curInputs = curStep.find("input[type='text'], input[type='range']"),
                isValid = true;

            $(".form-group").removeClass("has-error");
            if (curStepId === "step-3") {
                curInputs = curStep.find("input[type='text']");
                var filled_area = 0;
                curInputs.each(function () {
                    if ($(this).val().trim() !== '') {
                        filled_area += 1;
                    }
                });
                if (filled_area === 0) {
                    isValid = false;
                    curInputs.closest(".form-group").addClass("has-error");
                }
            } else {
                curInputs.each(function () {
                    if (!this.validity.valid) {
                        isValid = false;
                        $(this).closest(".form-group").addClass("has-error");
                    }
                });
            }


            if (!isValid || !nextStepLink.length) return;

            // mark current as completed
            curStepLink.removeClass('active').addClass('completed').css('background-color', '#ff810e');
            // remove previous step color
            // curStepLink.css('background-color', '#333');
            // enable & activate next
            nextStepLink.removeClass('disabled').addClass('active').css('background-color', '#ff810e');

            allWells.hide();
            $(nextStepLink.attr('href')).show();
        });

        return () => {
            navListItems.off('click.stepper');
            allNextBtn.off('click.stepper');
        };
    }, [activeTab, CreatorStatus]);
    function setNextBtnState(nextBtn, isEnabled) {
        if (!nextBtn) return;
        nextBtn.disabled = !isEnabled;
        if (isEnabled) {
            nextBtn.style.opacity = "1";
            nextBtn.style.pointerEvents = "auto";
            nextBtn.style.backgroundColor = "#ff810e";
        } else {
            nextBtn.style.opacity = "0.4";
            nextBtn.style.pointerEvents = "none";
            nextBtn.style.backgroundColor = "#000";
        }
    }
    function handleChangesTermsCondition() {
        const checkbox1 = document.getElementById('flexCheckDefault');
        const checkbox2 = document.getElementById('flexCheckChecked');

        // Get Next button ONLY from step-1
        const step1 = document.getElementById('step-1');
        const nextBtn = step1.querySelector('.nextBtn');

        const shouldEnable = checkbox1.checked && checkbox2.checked;
        setNextBtnState(nextBtn, shouldEnable);
    }
    function handleAgeRangeChange(e) {
        const step1 = document.getElementById('step-2');
        const nextBtn = step1.querySelector('.nextBtn');
        const new_min = Number(e.target.value);
        setNextBtnState(nextBtn, new_min >= 14);
        let rangeSliderValue = document.getElementsByClassName("range-slider__value_");
        if (rangeSliderValue) {
            rangeSliderValue[0].innerText = new_min;
        }
    }
    function handleSocialMediaInputChange() {
        const step3 = document.getElementById('step-3');
        const nextBtn = step3.querySelector('.nextBtn');
        const inputs = step3.querySelectorAll("input[type='text']");
        let hasValue = false;
        inputs.forEach((input) => {
            if (input.value.trim() !== '') {
                hasValue = true;
            }
        });
        setNextBtnState(nextBtn, hasValue);
    }
    function handleSocialMediaChange() {
        // get all steper form data to send backend when your user click next button.
        var Step3FormData = $('#step-3').find("input[type='text']");
        // get all data from step 3
        // var socialMediaData = {};
        Step3FormData.each(function () {
            var inputPlaceholder = $(this).attr('name') || $(this).attr('placeholder');
            var inputValue = $(this).val().trim();
            if (inputValue !== '') {
                socialMediaData[inputPlaceholder] = inputValue;
            }
        });
        // get selected age from step 2
        var step2Input = $('#step-2').find("input[type='range']");
        var ageValue = parseInt(step2Input.val());
        socialMediaData['age'] = ageValue;
        // console.log(socialMediaData);
        // setSocialMediaLinks(socialMediaData);
        // enable next button

        // After get the data you can send to backend.
    }
    async function handleSubmitCreatorApplication(e) {
        e.preventDefault();
        // console.log("sociallogs", socialMediaData);
        if (socialMediaData) {
            // send socialMediaLinks state to backend to save the data.
            socialMediaData.user_id = user.user_id;
            let send_data = await makeAPI('/api/creator_data','post',false,{data : {...socialMediaData}});
            if (send_data.status === 'S') {
                // setActiveTab('become a creator');
                setCreatorStatus('processing');
                alert("Creator Application Submitted Successfully!");
            } else {
                alert('not submitted successfully')
            }
        }

    }
    async function GetCreatorStat() {
        if (!user?.user_id) return;
        try {
            var creator_status = await makeAPI('/api/get_creator_status',"post",false,{user_id : user.user_id});
            // console.log("Creator_Srt",creator_status);
            
            if(creator_status.status === "S"){
                // show creator code
                setCreatorStatus('creator_dashboard');
            }else if(creator_status.status === "E"){
                // under verification
                setCreatorStatus('processing');
                // setCreatorStatus('creator_dashboard');

            }else{
                // other than show form
                setCreatorStatus('form');
                // setCreatorStatus('creator_dashboard');
            }

        } catch (error) {
            console.log("eroor",error);
            // setCreatorStatus('form');
        }
        
    }
    async function support_creator(e,key) {
        // alert('submit')
        // e.preventDefault();
        var creator_code_by_user = document.getElementById('creator_code')?.value;
        if(!creator_code_by_user || creator_code_by_user.trim().length > 20){
            alert('Invalid Creator Code !')
            return; 
        }
        try {
            let data = {
                user_id:user.user_id,
                code :creator_code_by_user,
                key:'S'
            }
            const support_creator_by_user = await makeAPI('/api/support_creator','post',false,data);
            if(support_creator_by_user.status === "S"){
                alert('Successfully supported a creator !')
                document.getElementById('creator_code').disabled = true;
                setbutton(true);
            }else if(support_creator_by_user.status === "E" && support_creator_by_user.message === "Already Supporting this Creator."){
                alert('Already Supporting this Creator. use another code !');
                document.getElementById('creator_code').disabled = false;

            }else{
                document.getElementById('creator_code').disabled = false;
                alert(support_creator_by_user.message);
            }
        } catch (error) {
            console.error(error);
        }
        // document.getElementById('creator_code').disabled =true;
        // setbutton(true);
    }
    function CheckCreatorCodeChanges(params) {
        // alert();
        var creator_code_submit_btn = document.getElementById('creator_code_submit');
        // creator_code_submit_btn.disabled = false;
        creator_code_submit_btn.style.opacity = "1";
        creator_code_submit_btn.style.pointerEvents = "auto";
    }
    async function GetCreatorCode(params) {
        if (!user?.user_id) return;
        try {
            var get_creator_code = await makeAPI('/api/get_creator_code','post',false,{user_id:user?.user_id});
            if(get_creator_code.status === 'S'){
                // Change stat in toggle view dashboard.
                if(get_creator_code?.verified_creator === true){
                    document.getElementById('toggle-btn-become a creator').innerText = "View My Dashboard";
        
                }
                // Enable Stop Button
                setbutton(true);
                // set the creator code in input box
                document.getElementById('creator_code').value = get_creator_code?.code?.toUpperCase();
                document.getElementById('creator_code').disabled = true;
                document.getElementById('creator_code_submit').classList.add('disabledbutton');
            }else{
                // Change stat in toggle view dashboard.
                if(get_creator_code?.verified_creator === true){
                    document.getElementById('toggle-btn-become a creator').innerText = "View My Dashboard";
        
                }
                // Enable input 
                setbutton(false);
                document.getElementById('creator_code').value = get_creator_code?.code?.toUpperCase() || '';
                document.getElementById('creator_code_submit')?.classList.add('disabledbutton');
                document.getElementById('creator_code_stop').style.opacity = "0";
                document.getElementById('creator_code_stop').style.pointerEvents = "none";
            }
        } catch (error) {
            console.log("Error",error);
        }
    }
    async function stop_creator_code (e,key){
        // alert()
        e.preventDefault();
        // Enable submit button and input text;
        // change the stat in Backend.
        // Enbale input box
        
        try {
            
            let code = document.getElementById('creator_code')?.value;
            let data = {
                user_id : user?.user_id,
                code,
                key:"R"
            }
            var change_stat = await makeAPI('/api/support_creator','post',false,data);
            if(change_stat.status === "S"){
                console.log("Change stat successfully");
                document.getElementById('creator_code').value = "";
                document.getElementById('creator_code').disabled = false;

                // code.disabled = true;
            }else{
                console.log("Not successfully change stat");
                document.getElementById('creator_code').value = "";
                document.getElementById('creator_code').disabled = false;
            }
        } catch (error) {
            console.error(error);
        }
        setbutton(false);
        // let submit_btn = document.getElementById('creator_code_submit');
        // submit_btn.classList.add('disabledbutton');
    }
    function enablePreloader() {
        const preloader = document.getElementById("preloader");
        if (preloader) {
            preloader.style.visibility = "visible";
            preloader.style.opacity = "1";
        }
        setTimeout(() => {
            disablePreloader();
        }, 500);
    }

    function disablePreloader() {
        const preloader = document.getElementById("preloader");
        if (preloader) {
            preloader.style.opacity = "0";
            setTimeout(() => {
                preloader.style.visibility = "hidden";
            }, 1000);
        }
    }

    function openLoginModal() {
        if (window.UIkit && typeof window.UIkit.modal === "function") {
            window.UIkit.modal("#modal-login", { container: false }).show();
            return;
        }
        window.location.href = "/";
    }

    if (!isLoggedIn) {
        return (
            <>
                <div className="container creator-brochure-wrap pd-top-120 pd-bottom-90">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="creator-brochure-hero text-center">
                                <h2 className="title move-line-3d mb-2">Creator Community</h2>
                                <p className="creator-brochure-subtitle">
                                    One place to support your favorite creators and apply to become a creator on CGES.club.
                                </p>
                                <button className="btn btn-base creator-brochure-cta" onClick={openLoginModal}>
                                    Login To Continue
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="row g-3 justify-content-center mt-2">
                        <div className="col-lg-5 col-md-10">
                            <div className="creator-brochure-card">
                                <img src={getViteImage("reference/11.avif")} alt="Support creator" className="creator-brochure-img" />
                                <h4>Support a Creator</h4>
                                <ul className="creator-brochure-list">
                                    <li>Enter a creator code to support a creator you follow.</li>
                                    <li>Your gameplay stays the same, support happens in the background.</li>
                                    <li>Get creator-linked offers and voucher benefits.</li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-5 col-md-10">
                            <div className="creator-brochure-card">
                                <img src={getViteImage("reference/10.avif")} alt="Become creator" className="creator-brochure-img" />
                                <h4>Become a Creator</h4>
                                <ul className="creator-brochure-list">
                                    <li>Apply through a guided 4-step form.</li>
                                    <li>Share your socials and creator profile details.</li>
                                    <li>Track application status and access creator dashboard after approval.</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="row justify-content-center mt-2">
                        <div className="col-lg-10">
                            <div className="creator-brochure-steps">
                                <h5 className="text-center mb-3">How It Works</h5>
                                <div className="creator-brochure-step-grid">
                                    <div className="creator-step-chip">1. Login to your account</div>
                                    <div className="creator-step-chip">2. Choose Support or Become Creator</div>
                                    <div className="creator-step-chip">3. Complete setup and submit</div>
                                    <div className="creator-step-chip">4. Start using creator benefits</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <style>{`
                    .creator-brochure-wrap {
                        min-height: 72vh;
                    }
                    .creator-brochure-hero {
                        background: radial-gradient(circle at top right, rgba(255, 129, 14, 0.26), transparent 42%), #121212;
                        border: 1px solid #3a3a3a;
                        border-radius: 14px;
                        padding: 26px 20px;
                    }
                    .creator-brochure-subtitle {
                        max-width: 720px;
                        margin: 0 auto 14px;
                        color: #e4e4e4;
                    }
                    .creator-brochure-cta {
                        border: 1px solid #ff810e;
                        background: #161616;
                        color: #fff;
                        min-width: 220px;
                    }
                    .creator-brochure-card {
                        height: 100%;
                        background: linear-gradient(180deg, #171717 0%, #101010 100%);
                        border: 1px solid #333;
                        border-radius: 12px;
                        padding: 18px;
                        color: #e4e4e4;
                    }
                    .creator-brochure-img {
                        width: 100%;
                        max-height: 160px;
                        object-fit: contain;
                        margin-bottom: 10px;
                        border-radius: 8px;
                        background: #0c0c0c;
                    }
                    .creator-brochure-card h4 {
                        color: var(--main-color-one);
                        margin-bottom: 10px;
                    }
                    .creator-brochure-list {
                        margin: 0;
                        padding-left: 18px;
                    }
                    .creator-brochure-list li {
                        margin-bottom: 9px;
                    }
                    .creator-brochure-steps {
                        margin-top: 12px;
                        padding: 20px;
                        border: 1px solid #333;
                        border-radius: 12px;
                        background: #121212;
                    }
                    .creator-brochure-step-grid {
                        display: grid;
                        grid-template-columns: repeat(2, minmax(0, 1fr));
                        gap: 10px;
                    }
                    .creator-step-chip {
                        border: 1px dashed #ff810e;
                        background: #181818;
                        color: #f3f3f3;
                        padding: 10px 12px;
                        border-radius: 8px;
                        text-align: center;
                        font-size: 14px;
                    }
                    @media (max-width: 767px) {
                        .creator-brochure-wrap {
                            min-height: auto;
                        }
                        .creator-brochure-hero {
                            padding: 20px 14px;
                        }
                        .creator-brochure-step-grid {
                            grid-template-columns: 1fr;
                        }
                        .creator-brochure-cta {
                            width: 100%;
                        }
                    }
                `}</style>
            </>
        );
    }

    return (
        <>
            <div className="account-settings-wrap uk-padding-small uk-padding-medium@m details mt-4 mb-4 price-meta">
                <div className="row justify-content-">
                    <div className="col-lg-2"></div>
                    <div className="col-lg-8 col-12" style={{ background: "rgb(22,22,22,22)" }}>

                        <div className="col-12 d-flex flex-wrap justify-content-center gap-2 mb-3 mt-5">
                            {["support creator", "become a creator"].map((tab) => (
                                <button
                                    key={tab}
                                    onClick={() => {setActiveTab(tab); enablePreloader()}}
                                    style={(activeTab === tab ? { backgroundColor: "#FF810E", color: '#fff', padding: "16px 16px",opacity:"1" } : { border: '1px solid #FF810E', backgroundColor: "transparent", color: '#fff', padding: "0px 16px",lineHeight:"55px" })}
                                    className="btn btn-default"
                                    id={`toggle-btn-${tab}`}
                                    disabled={activeTab === tab}
                                >
                                    {/* {tab.charAt(0).toUpperCase() + tab.slice(1)} */}
                                    {/* {tab.replace(/\b\w/g, c => c.toUpperCase())} */}
                                    {tab === "support creator" ? "Support a Creator" :"Become a Creator"}
                                </button>
                            ))}
                        </div>



                        <div className=" row ">
                            <div className="col-lg-2"></div>

                            <div className="col-lg-8 col-12 mb-3">
                                {activeTab === "support creator" ? (
                                    <div className="form-login creator-card creator-support-form">
                                        <div>
                                            <img className="" src={getViteImage("reference/11.avif")} style={{ margin:"auto",display:"block" ,width:"40%"}}></img>
                                        </div>
                                        <div className="d-flex justify-content-center">
                                            <div className="rounded-bottom" >
                                                <p><strong>💙 Support a creator you love!</strong></p>
                                                <ul >
                                                   
                                                    <li className="mb-2">Use their creator code to support.</li>
                                                    <li className="mb-2">Your gameplay and rewards stay exactly the same.</li>
                                                    <li className="mb-2">And whenever you spend on the platform, a small share goes to the creator-at no extra cost to you.</li>
                                                    <li className="mb-2">You get additional discount on all Vouchers & Gift cards that you redeem (3%)</li>
                                                    <li className="mb-2">Follow your favourite creator to receive special monthly offers such as discount vouchers and gift cards.</li>
                                                    {/* <li>For support or queries, contact: <a href='mailto:info@cges.club' style={{ color: "#FF810E" }}>info@cges.club</a></li> */}
                                                </ul>
                                                {/* <p className="text-secondary m-0">
                                                    Disclaimer: All contests and rewards are solely organized by CGES.club.
                                                </p> */}
                                            </div>
                                        </div><br/>
                                        <div className="single-input-inner style-border">
                                            <label className='' >Support Your Creator :</label>
                                            <input type="text" className="uk-input mt-1" id="creator_code" placeholder="Enter creator code" style={{textTransform:"uppercase"}} onChange={CheckCreatorCodeChanges} maxLength={30}></input>
                                        </div>
                                        {showbutton ? (
                                            <button type="submit" className="uk-button uk-button-danger uk-width-1-1 creator-action-btn text-white mt-2" required onClick={stop_creator_code} id="creator_code_stop"
                                            style={{border:"1px solid #fff"}}
                                            >Stop</button>
                                        ) : (
                                            <div className="col-12 col-lg-6 offset-lg-3 d-flex justify-content-end pt-2">
                                                <button type="submit" class="uk-button uk-button-danger creator-action-btn mt-2 disabledbutton" required onClick={support_creator} style={{ color: "rgb(255, 255, 255)", height: "45px", lineHeight: "11px", display: "block", backgroundColor: "#ff810e", border: "1px solid #FFF" }} id="creator_code_submit">Submit</button>
                                            </div>
                                        )}

                                    </div>
                                ) : ("")
                                }
                                {activeTab === "become a creator" ? (
                                    CreatorStatus === "form" ? (
                                        <>
                                            {/* <div class="container"> */}
                                            <div className="stepwizard">
                                                <div className="stepwizard-row setup-panel">
                                                    <div className="stepwizard-step">
                                                        <a href="#step-1" type="button" className="btn btn-firsts btn-circle active">1</a>
                                                        <p><small>Start</small></p>
                                                    </div>
                                                    <div className="stepwizard-step">
                                                        <a href="#step-2" type="button" className="btn btn-default btn-circle disabled" >2</a>
                                                        <p><small>Age</small></p>
                                                    </div>
                                                    <div className="stepwizard-step">
                                                        <a href="#step-3" type="button" className="btn btn-default btn-circle disabled" >3</a>
                                                        <p><small>Socials </small></p>
                                                    </div>
                                                    <div className="stepwizard-step">
                                                        <a href="#step-4" type="button" className="btn btn-default btn-circle disabled " >4</a>
                                                        <p><small>Account</small></p>
                                                    </div>
                                                </div>
                                            </div>

                                            <form >
                                                <div className="panel panel-primary setup-content" id="step-1">
                                                    <div className="panel-heading mb-3 mt-3">
                                                        <h4 className="panel-title text-center">Creator Community</h4>
                                                        <p style={{ fontSize: "16px" }}>Creator Community on CGES.club is a space where creators connect with gamers, share their content, and earn rewards by being supported by the community—while helping grow the CGES ecosystem together.</p>
                                                    </div>
                                                    <div className="panel-heading mb-3 mt-3">
                                                        <h4 className="panel-title text-center">Let's get started!</h4>
                                                    </div>
                                                    <div className="panel-body">
                                                        <div className="form-check">
                                                            <input className="creator-check" type="checkbox" value="1" id="flexCheckDefault" style={{ width: "20px", height: "20px", verticalAlign: "middle", float: "left", cursor: "pointer", marginLeft: "-24px", marginTop: "5px" }} onChange={handleChangesTermsCondition} />
                                                            <div style={{ position: "relative", left: "10px" }}>
                                                                <label className="form-check-label" for="flexCheckDefault">
                                                                    <p style={{ fontSize: "16px" }}>I confirm that I will always act in a respectful and professional manner toward other Creators and Community Managers.
                                                                    </p>
                                                                </label>
                                                            </div>


                                                        </div>
                                                        <div className="form-check">
                                                            <input className="creator-check" type="checkbox" value="2" id="flexCheckChecked" onChange={handleChangesTermsCondition} style={{ width: "20px", height: "20px", verticalAlign: "middle", float: "left", cursor: "pointer", marginLeft: "-24px", marginTop: "5px" }} />
                                                            <div style={{ position: "relative", left: "10px" }}>
                                                                <label className="form-check-label" for="flexCheckDefault">
                                                                    <p style={{ fontSize: "16px" }}> I also confirm that I have 100+ followers on at least one platform (YouTube, Instagram, Twitch, or Discord).
                                                                    </p>
                                                                </label>
                                                            </div>
                                                        </div>

                                                        {/* <button className="btn btn-primary " type="button">Next</button> */}
                                                        <button type="button" className="uk-button uk-button-danger uk-width-1-1 nextBtn creator-action-btn mt-2 mb-3 text-white disabledbutton" required disabled
                                                            style={{backgroundColor:"#000"}}
                                                        >Next</button>

                                                    </div>

                                                </div>

                                                <div className="panel panel-primary setup-content" id="step-2">
                                                    <div className="panel-heading mt-2">
                                                        <h4 className="panel-title text-center">Age Confirmation!</h4>
                                                    </div>
                                                    <div className="panel-body range-slider">
                                                        <div className="form-group" style={{ margin: "20px" }}>
                                                            <label className="control-label">(You must be at least 13 years old)</label> <br />
                                                            <input type="range" id="ageRange" required="required" className="range-input mt-2" placeholder="Enter Your Age" defaultValue={13} min={13} max={100} onChange={async (e) => {
                                                                handleAgeRangeChange(e);

                                                            }} style={{ width: "60%" }} />
                                                            <span className="range-slider__value_" style={{ left: '20%', position: "relative" }}>13</span>
                                                            <small id="ageError" className="text-danger d-none">
                                                                You must be at least 13 years old
                                                            </small>
                                                        </div>


                                                        {/* <button className="btn btn-primary nextBtn pull-right" type="button">Next</button> */}
                                                        <button type="button" className="uk-button uk-button-danger uk-width-1-1 nextBtn creator-action-btn mt-1 mb-3 text-white disabledbutton" required disabled
                                                        style={{backgroundColor:"#000"}}
                                                        >Next</button>
                                                    </div>
                                                </div>

                                                <div className="panel panel-primary setup-content" id="step-3">
                                                    <div className="panel-heading mt-2">
                                                        <h4 className="panel-title">Familiar on Social Media</h4>
                                                    </div>
                                                    <div className="panel-body form-login creator-social-form p-0 m-1" onInput={handleSocialMediaInputChange} onChange={handleSocialMediaInputChange}>
                                                        <div className="creator-social-notes">
                                                            <div className="note-item">Followers above 100 are mandatory.</div>
                                                            <div className="note-item">At least one social media link is required.</div>
                                                        </div>
                                                        <div className="single-input-inner style-border">
                                                            <label className="control-label mb-2">Youtube</label>
                                                            <input maxlength="200" type="text" required="required" className="uk-input" name="youtube" placeholder="Channel Name / link" />
                                                        </div>
                                                        <div className="single-input-inner style-border">
                                                            <label className="control-label mb-2">Instagram</label>
                                                            <input maxlength="200" type="text" required="required" className="uk-input" name="instagram" placeholder="username / link" />
                                                        </div>
                                                        <div className="single-input-inner style-border">
                                                            <label className="control-label mb-2">Discord</label>
                                                            <input maxlength="200" type="text" required="required" className="uk-input" name="discord" placeholder="server name / link" />
                                                        </div>
                                                        <div className="single-input-inner style-border">
                                                            <label className="control-label mb-2">Twitch</label>
                                                            <input maxlength="200" type="text" required="required" className="uk-input" name="twitch" placeholder="username / link" />
                                                        </div>
                                                        {/* <button className="btn btn-primary nextBtn pull-right" type="button">Next</button> */}
                                                        <button type="button" className="uk-button uk-button-danger uk-width-1-1 nextBtn creator-action-btn mt-2 mb-3 text-white disabledbutton" required disabled
                                                        style={{backgroundColor:"#000"}}
                                                        onClick={handleSocialMediaChange}>Next</button>
                                                    </div>
                                                </div>

                                                <div className="panel panel-primary setup-content" id="step-4">
                                                    <div className="panel-heading mt-2">
                                                        <h4 className="panel-title">You’re almost done!</h4>
                                                    </div>
                                                    <div className="panel-body">
                                                        {/* <div className="form-group">
                                                            <label className="control-label">Company Name</label>
                                                            <input maxlength="200" type="text" required="required" className="form-control" placeholder="Enter Company Name" />
                                                        </div>
                                                        <div className="form-group">
                                                            <label className="control-label">Company Address</label>
                                                            <input maxlength="200" type="text" required="required" className="form-control" placeholder="Enter Company Address" />
                                                        </div> */}
                                                        <p style={{ fontSize: "larger", padding: "5px" }}> Thanks for your submission. Our team will contact you at the earliest possible time.</p>
                                                        {/* <button class="btn btn-success pull-right" type="submit">Finish!</button> */}
                                                        <button type="submit" className="uk-button uk-button-danger uk-width-1-1 nextBtn creator-action-btn text-white mt-2 mb-3" required onClick={handleSubmitCreatorApplication}>Submit</button>
                                                    </div>
                                                </div>
                                            </form>
                                            {/* </div> */}

                                        </>
                                    ) : CreatorStatus === "creator_dashboard" ? (
                                        <>
                                            <p className="text-center pt-5"> <span>Note:</span> View your Creator Dashboard by clicking below button</p>
                                                <div className="col-12 col-lg-6 offset-lg-3 d-flex justify-content-end pt-2">
                                                    <Link
                                                        to="/creator-admin"
                                                        className="uk-button uk-button-danger text-white mt-2"
                                                        style={{
                                                            height: "45px",
                                                            lineHeight: "15px",
                                                            display: "block",
                                                            backgroundColor: "#000000",
                                                            border: "1px solid #Ff810e",
                                                            textAlign: "center"
                                                        }}
                                                    >
                                                        View Dashboard
                                                    </Link>
                                                </div>
                                        </>
                                    ) : CreatorStatus === "processing" ? (
                                                <>
                                                    <h5 className="text-center mt-2">Creator Application Status</h5>
                                                    {/* <img src="assets/img/cc.avif" style={{display:"block",margin:"auto",width:"300px",borderRadius:"20px"}}></img> */}
                                                    <img src={getViteImage("reference/10.avif")} style={{margin:"auto",display:"block",width:"45%"}}></img>
                                                    <p className="text-center" style={{
                                                        wordBreak: 'normal',
                                                        overflowWrap: 'normal',
                                                        whiteSpace: 'normal',
                                                        hyphens: 'none',
                                                    }}>Your request is being reviewed by our team. We’ll notify you once it's completed. We’re excited to have you take this step toward becoming part of CGES.club!</p>
                                                </>
                                    ) : null
                                    
                                ) : ("")}

                            </div>
                            <div className="col-lg-2">

                            </div>

                        </div>



                    </div>
                    <div className="col-lg-2"></div>

                </div>
            </div>
            <style>{`
                .account-settings-wrap .single-input-inner .form-control {
                    color: #e4e4e4;
                    background: #161616;
                    border: 1px solid #3d3d3d;
                }
                .account-settings-wrap .single-input-inner .form-control::placeholder {
                    color: #9ea0a6;
                }
                .account-settings-wrap .btn.btn-base {
                    border: 1px solid #ff810e;
                    background: #161616;
                }
                .creator-card {
                    margin: 0 auto;
                    max-width: 760px;
                    padding: 18px;
                    border-radius: 12px;
                    background: #0c1826;
                    border: 1px solid #1a2634;
                }
                .creator-support-form {
                    color: #e4e4e4;
                }
                .creator-support-form .rounded-bottom {
                    width: 100%;
                }
                .creator-support-form ul {
                    margin: 0;
                    padding-left: 20px;
                }
                body.dark-theme .creator-support-form .uk-input,
                .creator-support-form .uk-input {
                    color: #e4e4e4;
                    background: #000;
                    border: 1px solid #3d3d3d;
                    min-height: 44px;
                }
                .creator-check {
                    accent-color: #ff810e;
                }
                .setup-content {
                    width: 100%;
                    max-width: 760px;
                    margin: 0 auto;
                }
                .setup-content .panel-heading,
                .setup-content .panel-body {
                    text-align: center;
                }
                .setup-content .single-input-inner {
                    max-width: 560px;
                    margin-left: auto;
                    margin-right: auto;
                    text-align: left;
                }
                .setup-content .nextBtn {
                    max-width: 260px;
                    margin-left: auto !important;
                    margin-right: auto !important;
                    display: block;
                }
                .stepwizard-step p {
                    margin-top: 0px;
                    color: #666;
                }
                .stepwizard-row {
                    display: table-row;
                }
                .stepwizard {
                    display: table;
                    width: 100%;
                    position: relative;
                }
                .stepwizard .btn.disabled, .stepwizard .btn[disabled], .stepwizard fieldset[disabled] .btn {
                    opacity: 1 !important;
                    color: #bbb;
                }
                .stepwizard-row:before {
                    top: 14px;
                    bottom: 0;
                    position: absolute;
                    content: " ";
                    width: 100%;
                    height: 1px;
                    background-color: #333;
                    z-index: 0;
                }
                .stepwizard-step {
                    display: table-cell;
                    text-align: center;
                    position: relative;
                }
                .btn-circle {
                    width: 30px;
                    height: 30px;
                    text-align: center;
                    padding: 6px 0;
                    font-size: 12px;
                    border-radius: 15px;
                    line-height: 1.428571429;
                    color: #fff;
                    border: 1px solid #ff810e;
                    background: #161616;
                }
                .creator-social-form .single-input-inner {
                    width: 100%;
                    margin-bottom: 12px;
                }
                .creator-social-notes {
                    max-width: 560px;
                    margin: 6px auto 12px;
                    text-align: left;
                    font-size: 12px;
                    color: #d0d0d0;
                }
                .creator-social-notes .note-item {
                    display: flex;
                    align-items: flex-start;
                    gap: 6px;
                    margin-bottom: 4px;
                }
                .creator-social-notes .note-item:before {
                    content: "*";
                    color: #ff810e;
                    line-height: 1.2;
                }
                body.dark-theme .creator-social-form .uk-input,
                .creator-social-form .uk-input {
                    color: #e4e4e4;
                    background: #000;
                    border: 1px solid #3d3d3d;
                    min-height: 44px;
                }
                body.dark-theme .creator-social-form .uk-input::placeholder,
                .creator-social-form .uk-input::placeholder {
                    color: #e4e4e4;
                }
                .creator-action-btn {
                    // color: #fff !important;
                    // font-size: 16px;
                    // font-weight: 700;
                    // min-height: 44px;
                    // border-radius: 0;
                    // background: #ff810e !important;
                    // border: 1px solid #ff810e !important;
                    // line-height: 24px;
                }
                .disabledbutton {
                    pointer-events: none;
                    opacity: 0.4;
                }
                #ageRange {
                    -webkit-appearance: none;
                    appearance: none;
                    accent-color: #ff810e;
                    position: relative;
                    transform: scale(1.3); /* Or however big you want it */
                    transform-origin: 0 0;
                    background: transparent;
                }
                #ageRange::-webkit-slider-runnable-track {
                    height: 6px;
                    border-radius: 4px;
                    background: #3d3d3d;
                }
                #ageRange::-webkit-slider-thumb {
                    -webkit-appearance: none;
                    appearance: none;
                    width: 16px;
                    height: 16px;
                    border-radius: 50%;
                    margin-top: -5px;
                    background: #ff810e;
                    border: 0;
                }
                #ageRange::-moz-range-track {
                    height: 6px;
                    border-radius: 4px;
                    background: #3d3d3d;
                }
                #ageRange::-moz-range-thumb {
                    width: 16px;
                    height: 16px;
                    border-radius: 50%;
                    background: #ff810e;
                    border: 0;
                }
                #ageRange::-ms-track {
                    height: 6px;
                    background: transparent;
                    border-color: transparent;
                    color: transparent;
                }
                #ageRange::-ms-fill-lower,
                #ageRange::-ms-fill-upper {
                    background: #3d3d3d;
                    border-radius: 4px;
                }
                #ageRange::-ms-thumb {
                    width: 16px;
                    height: 16px;
                    border-radius: 50%;
                    background: #ff810e;
                    border: 0;
                }
                @media (max-width: 767px) {
                    .stepwizard {
                        overflow-x: auto;
                    }
                    .stepwizard-row {
                        min-width: 420px;
                    }
                    #ageRange {
                        width: 100% !important;
                        transform: none;
                    }
                    .range-slider__value_ {
                        left: 12px !important;
                    }
                    .creator-card {
                        padding: 14px;
                    }
                    .setup-content .nextBtn {
                        max-width: 100%;
                    }
                }
            `}</style>

        </>
    )

}
